import { FeatureKeys } from "@/config/feature-keys";
import {
  FaApple,
  FaBrain,
  FaClipboardCheck,
  FaGooglePlay,
  FaLink,
  FaMicrophone,
  FaSearchDollar,
  FaUser,
  FaUsersCog,
  FaBookReader,
  FaFileInvoiceDollar,
} from "react-icons/fa";
import { IoBarChart } from "react-icons/io5";
import { TbDevicesCog, TbFileSettings } from "react-icons/tb";
import {
  MdOutlineLocalPhone,
  MdOutlinePhonelink,
  MdSettings,
} from "react-icons/md";

const APP_PREFIX_PATH = "/app";

// NAVIGATION_MENU is nested; used only for UI menu rendering
export const NAVIGATION_MENU = [
  {
    key: "dashboard",
    featureKey: FeatureKeys.DASHBOARD,
    path: `${APP_PREFIX_PATH}/dashboard`,
    title: "Dashboard",
    icon: IoBarChart,
    submenu: [],
  },
  {
    key: "voice-calls",
    featureKey: null,
    path: null,
    title: "Voice Calls",
    icon: MdOutlineLocalPhone,
    submenu: [
      {
        key: "voicecalls.feedback",
        featureKey: FeatureKeys.VOICECALLS,
        path: `${APP_PREFIX_PATH}/call-reviews`,
        title: "Voice Calls Feedback",
        icon: MdOutlineLocalPhone,
        submenu: [],
      },
      {
        key: "voicecalls.analysis",
        featureKey: FeatureKeys.CALLSEVALUATION,
        path: `${APP_PREFIX_PATH}/calls-evaluation`,
        title: "Voice Call Analysis",
        icon: FaClipboardCheck,
        submenu: [],
      },
    ],
  },
  {
    key: "mobile-apps",
    featureKey: null,
    path: null,
    title: "Mobile Apps",
    icon: MdOutlinePhonelink,
    submenu: [
      {
        key: "mobile.playstore",
        featureKey: FeatureKeys.PLAYSTORE,
        path: `${APP_PREFIX_PATH}/play-store-reviews`,
        title: "Play Store",
        icon: FaGooglePlay,
        submenu: [],
      },
      {
        key: "mobile.appstore",
        featureKey: FeatureKeys.APPSTORE,
        path: `${APP_PREFIX_PATH}/app-store-reviews`,
        title: "App Store",
        icon: FaApple,
        submenu: [],
      },
    ],
  },
  {
    key: "billing.usage",
    featureKey: null,
    path: null,
    title: "Usage & Billing",
    icon: FaFileInvoiceDollar,
    submenu: [
      {
        key: "billing.usage",
        featureKey: FeatureKeys.USAGE,
        path: `${APP_PREFIX_PATH}/settings/usage-details`,
        title: "Usage Details",
        icon: FaSearchDollar,
        submenu: [],
      },
    ],
  },
  {
    key: "settings",
    featureKey: null,
    path: null,
    title: "Settings",
    icon: MdSettings,
    submenu: [
      {
        key: "settings.configuration",
        featureKey: FeatureKeys.CONFIGURATION,
        path: `${APP_PREFIX_PATH}/configuration`,
        title: "LLM Provider",
        icon: FaBrain,
        submenu: [],
      },
      {
        key: "settings.transcription",
        featureKey: FeatureKeys.TRANSCRIPTION,
        path: `${APP_PREFIX_PATH}/transcription`,
        title: "Speech-to-Text",
        icon: FaMicrophone,
        submenu: [],
      },
      {
        key: "settings.app_links",
        featureKey: FeatureKeys.APP_LINK,
        path: `${APP_PREFIX_PATH}/app-store-links`,
        title: "App Links",
        icon: FaLink,
        submenu: [],
      },
      {
        key: "settings.users",
        featureKey: FeatureKeys.USERS,
        path: `${APP_PREFIX_PATH}/settings/users`,
        title: "Users & Roles",
        icon: FaUser,
        submenu: [],
      },
      {
        key: "settings.roles",
        featureKey: FeatureKeys.ROLES,
        path: `${APP_PREFIX_PATH}/settings/roles`,
        title: "Roles Permissions",
        icon: FaUsersCog,
        submenu: [],
      },
      {
        key: "settings.call_evaluation_details",
        featureKey: FeatureKeys.CALLSEVALUATIONDETAILS,
        path: `${APP_PREFIX_PATH}/settings/call-evaluation-details`,
        title: "Call Evaluation Details",
        icon: FaClipboardCheck,
        submenu: [],
      },
    ],
  },
  {
    key: "apidocs",
    featureKey: null,
    path: null,
    title: "API Docs",
    icon: FaBookReader,
    submenu: [
      {
        key: "apidocs.voice_call",
        featureKey: FeatureKeys.API_DOCS,
        path: `${APP_PREFIX_PATH}/api-docs/voice-call`,
        title: "Voice Call Feedback",
        icon: TbFileSettings,
        submenu: [],
      },
      {
        key: "apidocs.call_evaluation",
        featureKey: FeatureKeys.API_DOCS,
        path: `${APP_PREFIX_PATH}/api-docs/call-evaluation`,
        title: "Voice Call Analysis",
        icon: TbDevicesCog,
        submenu: [],
      },
    ],
  },
];
